"use strict";
var timepicker_component_1 = require('./timepicker/timepicker.component');
exports.TimepickerComponent = timepicker_component_1.TimepickerComponent;



/*****************
 ** WEBPACK FOOTER
 ** ./~/ng2-bootstrap/components/timepicker.js
 ** module id = 832
 ** module chunks = 0
 **/